import axios from 'axios';
import { createActionAsync } from 'redux-act-async';
import { ROOT_URL } from 'constants/Config.js';
import get from 'lodash.get';

export const createRequestActions = ({
  type,
  url,
  method = 'get',
  path = 'data',
}) => createActionAsync(
  type,
  params => {
    const data = typeof params === 'function'
      ? {}
      : method === 'get' ? { params } : params;
    return axios[method](
      `${ROOT_URL}${url}`,
      data,
    );
  },
  {
    ok: {
      payloadReducer: (payload) => (
        {
          ...payload,
          response: get(payload.response.data, path),
        }
      ),
    },
  },
);



// WEBPACK FOOTER //
// ./src/actions/index.js